import React, { useRef, useEffect } from 'react';
import Webcam from "react-webcam";
import Quagga from 'quagga';

const BarcodeScannerComponent = ({ onDetected }) => {
    const webcamRef = useRef(null);

    useEffect(() => {
        Quagga.onDetected(onDetected);
        Quagga.init({
            inputStream: {
                type: "LiveStream",
                target: document.querySelector('#interactive'), // تارگت به div پایین اشاره دارد
                constraints: {
                    width: '100%',
                    height: 480,
                    facingMode: "environment" // استفاده از دوربین پشتی
                },
            },
            decoder: {
                readers: ["code_128_reader", "ean_reader", "ean_8_reader", "code_39_reader", "code_39_vin_reader", "codabar_reader", "upc_reader", "upc_e_reader", "i2of5_reader"] // اینجا می‌توانید انواع بارکدهای دیگر را نیز اضافه کنید
            },
            locate: true // این امکان را می‌دهد که quagga محل دقیق بارکد در تصویر را تشخیص دهد
        }, function(err) {
            if (err) {
                console.error(err);
                return;
            }
            Quagga.start();
        });

        return () => {
            Quagga.stop();
            Quagga.offDetected(onDetected);

        };
    }, []);

    return (
        <div id="interactive" className="viewport">
            <Webcam
                audio={true}
                ref={webcamRef}
                screenshotFormat="image/jpeg"
                width={'100%'}
                height={480}
                videoConstraints={{
                    width: '100%',
                    height: 480,
                    facingMode: "environment"
                }}
            />
        </div>
    );
};

export default BarcodeScannerComponent;
